<template>
  <div class="finance-warpper">
    <div class="bg-white flex align-center">
      <div class="flex align-center margin-right-sm">
        <span>年度：</span>
        <el-select v-model="year" placeholder="请选择">
          <el-option
            v-for="item in yearList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <twoLevel @SearchInfo="SearchInfo"/>
      <el-button type="primary" class="margin-left" v-if="project" @click="exportShuJuBiao">导出</el-button>
    </div>
    <div class="bg-white margin-top-sm">
      <div class="flex align-center justify-between margin-bottom-xs">
        <h3>{{ yearChiose }}年各项收入明细</h3>
        <div v-if="community && user.power === 7">
          <el-button type="primary" @click="incomeEdit(2)" class="margin-right">全年应收编辑</el-button>
          <el-button type="primary" @click="incomeEdit(3)">核定收入编辑</el-button>
        </div>

      </div>
      <el-table
        :data="income"
        border
        height="500"
        style="width: 100%">
        <el-table-column prop="xuhao" label="序号" width="60px" fixed="left"></el-table-column>
        <el-table-column prop="xiangmu" label="社区" width="200px" fixed="left"></el-table-column>
        <el-table-column prop="quanNianYingShou" label="全年应收"></el-table-column>
        <el-table-column prop="heDingShouRu" label="核定收入"></el-table-column>
        <el-table-column prop="yiShiXianShouRu" label="已实现收入"></el-table-column>
        <el-table-column prop="yingShouWeiShou" label="应收未收"></el-table-column>
        <el-table-column prop="beiZhu" label="备注" >
          <template slot-scope="scope" v-if="community">
          <el-input

            placeholder="请输入内容"
            v-model="scope.row.beiZhu"
            @focus="setDescId(scope.row.id)"
          @change="setDesc">
          </el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="bg-white margin-top-sm">
      <div class="flex align-center justify-between margin-bottom-xs">
        <h3>{{ yearChiose }}年各项支出明细</h3>
        <div v-if="community && user.power === 7">
          <el-button type="primary" @click="expenditureEdit(2)" class="margin-right">全年应付编辑</el-button>
          <el-button type="primary" @click="expenditureEdit(3)">核定支出编辑</el-button>
        </div>
      </div>
      <el-table
        :data="expenditure"
        border
        height="500"
        style="width: 100%">
        <el-table-column prop="xuhao" label="序号" width="60px"  fixed="left"></el-table-column>
        <el-table-column prop="xiangmu" label="社区" width="200px" fixed="left"></el-table-column>
        <el-table-column prop="quanNianYingShou" label="全年应付"></el-table-column>
        <el-table-column prop="heDingShouRu" label="核定支出"></el-table-column>
        <el-table-column prop="yiShiXianShouRu" label="已发生支出"></el-table-column>
        <el-table-column prop="yingShouWeiShou" label="应付未付"></el-table-column>
        <el-table-column prop="beiZhu" label="备注" >
          <template slot-scope="scope" v-if="community">
            <el-input

              placeholder="请输入内容"
              v-model="scope.row.beiZhu"
              @focus="setDescId(scope.row.id)"
              @change="setDesc">
            </el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <incomeEditDialog :year="yearChiose" :project="project" :projectName="projectName" :community="community"
                      :communityName="communityName" :incomeEditDialog="incomeEditDialog"
                      @cancelDialog="cancelDialog" :type="type"
    />

    <expenditureEditDialog :year="yearChiose" :project="project" :projectName="projectName" :community="community"
                           :communityName="communityName" :expenditureEditDialog="expenditureEditDialog"
                           @cancelDialog="cancelDialog" :type="type"
    />


  </div>
</template>

<script>
import incomeEditDialog from "@/views/pages/dialog/incomeEditDialog";
import expenditureEditDialog from "@/views/pages/dialog/expenditureEditDialog";
import twoLevel from "@/components/two-level";
import {optionList, year, zhDate} from "@/utils/utils";
import {addQuanNianBeiZhu, exportShuJuBiao, getShuJuBiao} from "@/api/caiwu";

export default {
  name: "year-finance",
  data() {
    return {
      yearList: optionList(true, year),
      year: zhDate(new Date(), 4),
      yearChiose: zhDate(new Date(), 4),
      project: 0,
      projectName: '',
      community: 0,
      communityName: '',
      income: [],
      expenditure: [],
      incomeEditDialog: false,
      expenditureEditDialog: false,
      type: 0,
      descId: 0,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.$emit("setIndex", this.$route.path, "财务管理 / 财务汇总", false);
  },
  components: {
    twoLevel,
    incomeEditDialog,
    expenditureEditDialog
  },
  methods: {
    //  备注
    async setDesc(e){
      let _state = await addQuanNianBeiZhu(this.project,
        this.community,
        this.year,
        this.descId,
        e
      )
      if(_state.status === 200){
        this.$message.success('更新成功')
        this.descId = ''
      }
    },
    setDescId(id){
      this.descId = id
    },
    //导出
    async exportShuJuBiao(){
      let _state = await exportShuJuBiao(
        this.project,
        this.community,
        this.year,
      )
      let blob = _state.data
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.setAttribute('download', this.projectName + '-' +(this.communityName?this.communityName:'') + '财务汇总.xls');
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },



    cancelDialog(val) {
      this.incomeEditDialog = false;
      this.expenditureEditDialog = false;
      this.type = 0
      this.getInfo();
    },
    //  收入编辑
    incomeEdit(num) {
      this.type = num
      this.incomeEditDialog = true
      // if (this.project && this.community) {
      //   this.type = num
      //   this.incomeEditDialog = true
      // } else {
      //   this.$message.info('请先选择社区及小区')
      // }
    },
    //  支出编辑
    expenditureEdit(num) {
      if (this.project && this.community) {
        this.type = num
        this.expenditureEditDialog = true
      } else {
        this.$message.info('请先选择社区及小区')
      }
    },
    //  获取收支明细
    async SearchInfo(val) {
      this.project = val.project
      this.projectName = val.projectName
      this.community = val.community
      this.communityName = val.communityName
      this.yearChiose = this.year
      if (this.project) {
        let _data = await getShuJuBiao(this.year, this.project, this.community)
        this.income = _data.data[0].xiangmu_one
        this.expenditure = _data.data[1].xiangmu_one
      } else {
        this.$message.info('请先选择社区及小区')
      }

    },
    //  获取收支明细
    async getInfo() {
      let _data = await getShuJuBiao(this.year, this.project, this.community)
      this.income = _data.data[0].xiangmu_one
      this.expenditure = _data.data[1].xiangmu_one
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.finance-warpper {

}
</style>
